"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.jsep = void 0;
var jsep_1 = __importDefault(require("jsep"));
exports.jsep = jsep_1["default"];
jsep_1["default"].addBinaryOp('**', 11, true);
var OPEN_PARENTHESIS_CODE = 40;
var CLOSE_PARENTHESIS_CODE = 41;
var SEQUENCE_EXPRESSION = 'SequenceExpression';
var sequenceExpressionPlugin = {
    name: 'the plugin',
    init: function (thisJsep) {
        thisJsep.hooks.add('gobble-token', function (env) {
            var context = env.context;
            if (!thisJsep.isIdentifierStart(context.code) && context.code === OPEN_PARENTHESIS_CODE) {
                context.index += 1;
                var nodes = context.gobbleExpressions(CLOSE_PARENTHESIS_CODE);
                if (context.code === CLOSE_PARENTHESIS_CODE) {
                    context.index += 1;
                    if (nodes.length > 0) {
                        env.node = {
                            type: SEQUENCE_EXPRESSION,
                            expression: nodes[0]
                        };
                    }
                }
                else {
                    context.throwError('Unclosed (');
                }
            }
        });
    }
};
jsep_1["default"].plugins.register(sequenceExpressionPlugin);
//# sourceMappingURL=jsep.js.map